import React, {useEffect} from "react"
import { useSignal } from "@preact/signals-react"
import { ModalSeeker } from "@ui-seeker/core"

import { ModalVideosContainer } from "./index"


export default function ModalCarouselImageSeeker({ isOpen, controller, multimedia = [], text=[], initPos=0, title="Videos", isVideo, ...props }) {
    const posImg = useSignal(initPos)

    useEffect(() => {
        posImg.value = initPos
    }, [initPos])

    return <ModalSeeker isOpen={isOpen} controller={controller} title={title} size="md" hideActions {...props}>
        <ModalVideosContainer videos={multimedia} initPos={posImg.value} />
    </ModalSeeker>
}